import React from 'react';
import './SubscriptionPaywallModal.css';

const SubscriptionPaywallModal = ({ onSubscribe, loading }) => {
  return (
    <div className="paywall-overlay">
      <div className="paywall-modal">
        <div className="paywall-content">
          <div className="paywall-header">
            <div className="paywall-icon">🔒</div>
            <h2>Your Trial Has Ended</h2>
            <p className="paywall-subtitle">Subscribe to continue learning</p>
          </div>

          <div className="paywall-features">
            <h3>Keep enjoying all features:</h3>
            <div className="feature-list">
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Unlimited video conversations with native speakers</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>AI-powered flashcard generation</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Personalized learning progress tracking</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Access to all languages and instructors</span>
              </div>
            </div>
          </div>

          <div className="paywall-pricing">
            <div className="pricing-box">
              <div className="price-amount">
                <span className="currency">$</span>
                <span className="dollars">5</span>
                <span className="cents">.99</span>
                <span className="period">/month</span>
              </div>
              <div className="price-note">Cancel anytime, no commitments</div>
            </div>
          </div>

          <div className="paywall-actions">
            <button
              className="paywall-subscribe-btn"
              onClick={onSubscribe}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Subscribe Now'}
            </button>
          </div>

          <div className="paywall-footer">
            <p>Secure payment powered by Stripe</p>
            <p className="footer-note">
              By subscribing, you agree to our Terms of Service and Privacy Policy
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPaywallModal;
